import { useState } from 'react';
import { Popup, Content } from './zone-info.styled';

export const ZoneInfo = ({ nodes }) => {
  const [showInfo, setShowInfo] = useState(false);

  const getNodes = () => {
    const values = [];
    for (let key in nodes) {
      if (nodes[key] === true) {
        values.push('У' + key);
        values.push('С' + key);
      } else {
        values.push(...nodes[key]);
      }
    }
    return values.join(',');
  };

  return (
    <Content onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
      <img src="/images/path-6.png" alt="" />
      {showInfo && (
        <Popup>
          <div />
          {getNodes()}
        </Popup>
      )}
    </Content>
  );
};
